import { Box, CircularProgress, Divider, FormHelperText, Tooltip, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FormikConfig } from 'formik';
import React from 'react';
import AccordionControlled from '../../../components/AccordionControlled/AccordionControlled';
import Details from '../../../components/Details/Details';
import FilterComponentV2 from '../../../components/TablegridWithFilters/FilterComponent/FilterComponentv2';
import TabsLayout from '../../../components/Tabs/TabsLayout';
import { getGemiInfo, getGemiInfoV3 } from '../../../lib/fetchers';
import { eliminateOjectNotTruthyValues, matchRefsWithData } from '../../../lib/helperFuncs';
import { gemiBasicInfoRefs, gemiBasicInfoV3Refs } from '../../../lib/static/details/staticDetails';
import { GemiBasicInfoFields, GemiBasicInfoV3Fields } from '../../../lib/static/filters/filterFields';
import { gemiBasicInfoInitialValues, gemiBasicInfoV3InitialValues } from '../../../lib/static/filters/initialValues';
import { gemiBasicInfoV3ValidationSchema, gemiBasicInfoValidationSchema } from '../../../lib/static/filters/ValidationSchema';
import Theme from '../../../Themes/main.theme';
import moment from 'moment';

const GemiInfo = () => {
  const [tab, setTab] = React.useState(0);
  const [data, setData] = React.useState<any>();
  const [datav3, setDatav3] = React.useState<any>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>();

  const business_application_v3_columns: GridColDef[] = [
    {
      sortable: false,
      field: 'kak',
      headerName: 'Κωδικός Αριθμός Καταχώρησης',
      minWidth: 100,
    },
    {
      sortable: false,
      field: 'appSubjectId',
      headerName: 'Κωδικός Θέματος Εφαρμογής',
      minWidth: 100,
    },
    {
      sortable: false,
      field: 'appSubjectDescr',
      headerName: 'Περιγραφή Θέματος Εφαρμογής',
      flex: 1,
      minWidth: 100,
      renderCell: (params) => <>
        <Tooltip PopperProps={{
          disablePortal: true
        }} title={params.row.appSubjectDescr}>
          <Typography>
            {params.row.appSubjectDescr}
          </Typography>
        </Tooltip>
      </>
    },
    {
      sortable: false,
      field: 'appDecisionStatusId',
      headerName: 'Κωδικός Κατάστασης Απόφασης',
    },
    {
      sortable: false,
      field: 'appDecisionStatusDescr',
      headerName: 'Περιγραφή Κατάστασης Απόφασης',
      renderCell: (params) => <>
        <Tooltip PopperProps={{
          disablePortal: true
        }} title={params.row.appDecisionStatusDescr}>
          <Typography>
            {params.row.appDecisionStatusDescr}
          </Typography>
        </Tooltip>
      </>
    },
    {
      sortable: false,
      field: 'appDate',
      headerName: 'Ημερομηνία Εφαρμογής',
      renderCell: (params) => params.row.appDate
        ? moment(params.row.appDate).format('DD/MM/YYYY').toLocaleString()
        : '-'
    },
    {
      sortable: false,
      field: 'appDecisionDate',
      headerName: 'Ημερομηνία Απόφασης',
      renderCell: (params) => params.row.appDecisionDate
        ? moment(params.row.appDecisionDate).format('DD/MM/YYYY').toLocaleString()
        : '-'
    },
    {
      sortable: false,
      field: 'appRegistrationDate',
      headerName: 'Ημερομηνία Εγγραφής',
      renderCell: (params) => params.row.appRegistrationDate
        ? moment(params.row.appRegistrationDate).format('DD/MM/YYYY').toLocaleString()
        : '-'
    },
    {
      sortable: false,
      field: 'deletionSubject',
      headerName: 'Ένδειξη Διαγραφής',
      renderCell: (params) => params.row.deletionSubject === 'true'
        ? 'Ναι'
        : 'Όχι'
    },
  ];
  const subject_v3_columns: GridColDef[] = [
    {
      field: 'professionId',
      headerName: 'Μοναδικός Αριθμός (ID) Δραστηριότητας',
      minWidth: 150,

    },
    {
      field: 'professionCode',
      headerName: 'Κωδικός Δραστηριότητας',
      flex: 1,
      minWidth: 170
    },
    {
      field: 'professionDescr',
      headerName: 'Περιγραφή Δραστηριότητας',
      flex: 1,
      minWidth: 170
    },
    {
      field: 'startDate',
      headerName: 'Ημερομηνία Έναρξης Δραστηριότητας',
      flex: 1,
      minWidth: 170,
      renderCell: (params) => params.row.endDate
        ? moment(params.row.endDate).format('DD/MM/YYYY').toLocaleString()
        : '-'
    },
    {
      field: 'endDate',
      headerName: 'Ημερομηνία Λήξης Δραστηριότητας',
      flex: 1,
      minWidth: 170,
      renderCell: (params) => params.row.endDate
        ? moment(params.row.endDate).format('DD/MM/YYYY').toLocaleString()
        : '-'
    },
  ];
  const subject_columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'Κωδικός Δραστηριότητας',
      minWidth: 150,

    },
    {
      field: 'startDate',
      headerName: 'Ημερομηνία έναρξης Δραστηριότητας',
      flex: 1,
      minWidth: 170,
      renderCell: (params) => params.row.startDate
        ? moment(params.row.startDate).format('DD/MM/YYYY').toLocaleString()
        : '-'
    },
    {
      field: 'endDate',
      headerName: 'Ημερομηνία λήξης δραστηριότητας',
      flex: 1,
      minWidth: 170,
      renderCell: (params) => params.row.endDate
        ? moment(params.row.endDate).format('DD/MM/YYYY').toLocaleString()
        : '-'
    },
  ];
  const stocks_columns: GridColDef[] = [
    {
      field: 'amount',
      headerName: 'Πλήθος μετοχών ή Μεριδίων',
      minWidth: 150,

    },
    {
      field: 'nominalPrice',
      headerName: 'Ονομαστική Αξία Μεριδίων',
      flex: 1,
      minWidth: 170,
    },
    {
      field: 'type',
      headerName: 'Τύπος μετοχών ή Μεριδίων',
      flex: 1,
      minWidth: 170,
    },
  ];
  const business_application_columns: GridColDef[] = [
    {
      field: 'appSubjectId',
      headerName: 'Κωδικός μεταβολής',
      flex: 0.3,
      sortable: false,
    },
    {
      field: 'appDate',
      headerName: 'Ημερομηνία αίτησης μεταβολής',
      flex: 0.5,
      sortable: false,
      renderCell: (params) => params.row.appDate
        ? moment(params.row.appDate).format('DD/MM/YYYY').toLocaleString()
        : '-'
    },
    {
      field: 'appDecisionDate',
      headerName: 'Ημερομηνία απόφασης Εταιρείας για μεταβολή',
      flex: 0.5,
      sortable: false,
      renderCell: (params) => params.row.appDecisionDate
        ? moment(params.row.appDecisionDate).format('DD/MM/YYYY').toLocaleString()
        : '-'
    },
    {
      field: 'appDecisionStatusId',
      headerName: 'Κατάσταση μεταβολής',
      flex: 0.3,
      sortable: false
    },
    {
      field: 'url',
      headerName: 'url αρχείου ανακοίνωσης',
      flex: 1.5,
      sortable: false,
      renderCell: (params) => <>
        <Tooltip PopperProps={{
          disablePortal: true
        }} title={params.row.url}>
          <Typography>
            {params.row.url}
          </Typography>
        </Tooltip>
      </>
    },
    {
      field: 'appRegistrationDate',
      headerName: 'Ημερομηνία καταχώρησης μεταβολής',
      flex: 0.4,
      sortable: false,
      renderCell: (params) => params.row.appRegistrationDate
        ? moment(params.row.appRegistrationDate).format('DD/MM/YYYY').toLocaleString()
        : '-'
    },
  ];

  const onSubmitBasicInfo = async (values: FormikConfig<any>) => {    
    setIsLoading(true);
    try {
      const response = await getGemiInfo(eliminateOjectNotTruthyValues(values));
      setError('');
      setData({
        ...response.data,
        businessTitle: response.data?.businessTitles
          ? response.data?.businessTitles?.businessTitle
          : '-'});
    } catch (error: any) {
      console.error(error);
      if (error.response.status === 400) {
        setError(error.response.data.message);
      }
    }
    setIsLoading(false);
  };
  
  const onSubmitBasicInfoV3 = async (values: FormikConfig<any>) => {        
    setIsLoading(true);    
    if (Object.values(values).filter(Boolean).length === 0) {      
      setError('Πρέπει να επιλέξετε τουλάχιστον ένα από τα πεδία ΑΦΜ, Αριθμός ΓΕΜΗ');
      setIsLoading(false);
      return;
    }    
    try {
      const response = await getGemiInfoV3(eliminateOjectNotTruthyValues(values));
      setError('');
      setDatav3(response.data);
    } catch (error: any) {
      console.error(error);
      if (error.response.status === 400) {
        setError(error.response.data.message);
      }
    }
    setIsLoading(false);
  };

  const details = matchRefsWithData(data, gemiBasicInfoRefs);
  const details_v3 = matchRefsWithData(datav3, gemiBasicInfoV3Refs);

  const tabLabels = [
    {
      label: <Typography variant='h4'>Βασικές Πληροφορίες</Typography>,
    },
    {
      label: <Typography variant='h4'>Προβολή Επιπλέον Βασικών Στοιχείων</Typography>,
    }
  ];

  const tab1 = <Box my={4} width='100%'>
    <FilterComponentV2
      title='Φίλτρο Αναζήτησης Στοιχείων από Μητρωο ΓΕΜΗ'
      validationSchema={gemiBasicInfoValidationSchema}
      filterFields={GemiBasicInfoFields}
      initialValues={gemiBasicInfoInitialValues}
      resetFilters={true}
      changeFilters={filterValues => onSubmitBasicInfo(filterValues)}
      validateOnBlur={false}
    />
    <Box mt={5}>
      {isLoading
        ? <Box sx={{ display: 'flex', justifyContent: 'center'}}>
          <CircularProgress />
        </Box>
        : error
          ? <Typography variant='h4' display='flex'
            justifyContent='center'>
            {error}
          </Typography> 
          : data
            ? <>
              <Typography variant='h4'>Βασικές Πληροφορίες</Typography>
              <Details rows={details}/>
              <Box sx={{mt: 3}}>
                <AccordionControlled
                  headers={['Δραστηριότητες Επιχείρησης', 'Μεταβολές Επιχείρησης', 'Μετοχές- Μερίδια Επιχείρησης']}
                  columns={[subject_columns, business_application_columns, stocks_columns]}
                  rows={[
                    data.businessSubjects.businessSubject,
                    data.businessApplications.businessApplication,
                    data.businessStocks.businessStock
                  ]}
                  isLoading={isLoading}/>
              </Box>
            </> 
            : null 
      }
    </Box>
  </Box>; 

  const tab2 = <Box my={4}>
    <FormHelperText sx={{mb: 1}}>
      <Typography variant='subtitle1'>
        <ul>
          <li>
            Η υπηρεσία αυτή αναζητάει και επιστρέφει τα βασικά στοιχεία μιας επιχείρησης στο
            Μητρώο ΓΕΜΗ με βάση <span style={{fontWeight: 'bold'}}> τον αριθμό ΓΕΜΗ ή τον ΑΦΜ </span>της επιχείρησης
          </li>
          <li>
            Στην είσοδο είναι υποχρεωτικό να συμπληρωθεί από 
            <span style={{fontWeight: 'bold'}}> τουλάχιστον ένα</span> τα πεδία ΑΦΜ και Αριθμός ΓΕΜΗ.
          </li>
        </ul>
      </Typography>
    </FormHelperText>
    <FilterComponentV2
      title='Φίλτρο Αναζήτησης Επιπλέον Στοιχείων από Μητρωο ΓΕΜΗ'
      validationSchema={gemiBasicInfoV3ValidationSchema}
      filterFields={GemiBasicInfoV3Fields}
      initialValues={gemiBasicInfoV3InitialValues}
      resetFilters={true}
      changeFilters={filterValues => onSubmitBasicInfoV3(filterValues)}
      validateOnBlur={false}
    />
    <Box mt={5}>
      {isLoading
        ? <Box sx={{ display: 'flex', justifyContent: 'center'}}>
          <CircularProgress />
        </Box>
        : error
          ? <Typography variant='h4' display='flex'
            justifyContent='center'>
            {error}
          </Typography> 
          : datav3
            ? <>
              <Typography variant='h4'>Βασικές Πληροφορίες</Typography>
              <Details rows={details_v3}/>
              <Box sx={{mt: 3}}>
                <AccordionControlled
                  headers={['Εφαρμογές Επιχείρησης', 'Δραστηριότητες Επιχείρησης']}
                  columns={[business_application_v3_columns, subject_v3_columns]}
                  rows={[
                    datav3.businessApplications,
                    datav3.businessSubjects
                  ]}
                  isLoading={isLoading}/>
              </Box>
            </>
            : null
      }
    </Box>
  </Box>;
  const tabContent = [
    tab1,
    tab2
  ];

  return (
    <>
      <Box mt={5}>
        <Typography sx={{ my: 2 }} variant='h2'
          color={Theme?.labelColor?.main}>Βασικές Πληροφορίες από Μητρώο ΓΕΜΗ</Typography>
        <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />
        <TabsLayout
          tab={tab}
          setTab={setTab}
          tabLabels={tabLabels}
          tabContent={tabContent}
          resetFilters={() => {
            setData(undefined);
            setDatav3(undefined);
            setError('');
          }}
        />
      </Box>
    </>
  );
};

export default GemiInfo;